import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {DigestTypeEnum} from 'nutshell-graphql-types';
import type {
    GetDigestConfiguration as GetDigestConfigurationQuery,
    GetDigestConfigurationVariables as GetDigestConfigurationQueryVariables,
} from 'nutshell-graphql-types';

import GET_DIGEST_CONFIGURATION from '../queries/get-digest-configuration.graphql';

export const useGetDigestConfiguration = (digestType: DigestTypeEnum) => {
    const {loading, data, error, refetch} = useQuery<
        GetDigestConfigurationQuery,
        GetDigestConfigurationQueryVariables
    >(GET_DIGEST_CONFIGURATION, {
        variables: {digestType},
        fetchPolicy: 'cache-and-network',
    });

    const configuration = data ? data.digestConfiguration : null;

    return {
        isLoading: loading && !configuration,
        configuration,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
